import { ServiceArea, WayPoint } from '@bringg/types';
import { Map as MapboxMap, LngLatBounds } from 'mapbox-gl';
import { convertImageMarkerToFeature, DEFAULT_ZOOM, homeMarkerId } from '../../utils/markers-manager';
import { DriverLocation } from '../mapbox-route-tracker';
import { RouteLocation } from 'types/common.consts';
import { MapboxMarkerData } from '../../mapbox';

export const fitBoundsByRouteAndWayPoints = ({
	map,
	route,
	wayPoints,
	driverLocation
}: {
	map: MapboxMap;
	route: RouteLocation[];
	wayPoints: WayPoint[];
	driverLocation?: DriverLocation;
}) => {
	if (!map) {
		return;
	}
	const bounds = getCurrentBounds(map);

	driverLocation && bounds.extend([driverLocation.lng, driverLocation.lat]);
	route.forEach(item => {
		bounds.extend([item.lng, item.lat]);
	});

	wayPoints.forEach(item => {
		bounds.extend([item.lng, item.lat]);
	});

	if (!bounds.isEmpty()) {
		map.fitBounds(bounds, { padding: 70, maxZoom: DEFAULT_ZOOM });
	}
};

export const fitBoundsByServiceArea = (map: MapboxMap, serviceAreas: ServiceArea[]) => {
	if (!map) {
		return;
	}
	const bounds = getCurrentBounds(map);
	serviceAreas.forEach(serviceArea => {
		[serviceArea.polygon].flat().forEach((cord: any) => {
			bounds.extend(cord);
		});
	});

	if (!bounds.isEmpty()) {
		map.fitBounds(bounds, { maxZoom: DEFAULT_ZOOM });
	}
};

export const fitBoundsByMarkers = (map: MapboxMap, markers: MapboxMarkerData[]) => {
	if (!map) {
		return;
	}

	const markersAsFeatures = markers.map(marker => {
		return convertImageMarkerToFeature(marker);
	});

	const bounds = getCurrentBounds(map);
	markersAsFeatures.forEach(feature => {
		if (feature.id !== homeMarkerId) {
			//@ts-ignore
			bounds.extend(feature.geometry.coordinates);
		}
	});

	if (!bounds.isEmpty()) {
		map.fitBounds(bounds, { padding: 120, maxZoom: DEFAULT_ZOOM });
	}
};

const getCurrentBounds = (map: MapboxMap) => {
	const currentBounds = map.getBounds();
	return new LngLatBounds(currentBounds.sw, currentBounds.ne);
};
